import routerHistory from '../../routerHistory';
import { getLogger } from '../../services/logger';

const debug = getLogger('listeners:route:routeUtils');

let getUriParam = regex => {
  let path = routerHistory.getCurrentLocation().pathname;
  let result = null;
  let uriParts = path.match(regex);

  if (uriParts) {
    if (uriParts.length === 1) {
      result = uriParts[0].split('/')[2];
    } else {
      debug.error('Wrong url format url: "%s" | pattern: "%s"', path, regex);
    }
  }
  return result;
};

export let getClassId = () => {
  let regex = '/classroom/[a-zA-Z0-9.-]+';
  return getUriParam(regex);
};

export let inClassroomRoute = () => {
  let classId = getClassId();
  return classId !== null && classId !== undefined;
};

export let getBookId = () => {
  let regex = '/book/[a-zA-Z0-9.-]+';
  return getUriParam(regex);
};

export let getDiscussionId = () => {
  let regex = '/discussions/[a-zA-Z0-9.-]+';
  return getUriParam(regex);
};
